
import axios from 'axios';
import HTTPService from './HTTP.service';

class PageHitService {
	async getPageHitId(partnerId){

		const url = HTTPService.getURLForService('pagehit');
		const formData = new FormData();
		formData.append('id', partnerId);

		return axios.post(url, formData).then(
			(results) => {
				if ( results.data.statusCode!==201) return Promise.reject(results.data.message);
				const pagehitId = results.data.data._id;
				return pagehitId;
			}
		);
	}
}

const pageHitService = new PageHitService();

export default pageHitService;


// WEBPACK FOOTER //
// ./src/services/PageHit.service.js